import React from 'react';

export function AtualizacaoSuporte({ modalData }) {
  const escapedValue = JSON.stringify('modalData', modalData);
  console.log(escapedValue);

  return (
    <div>
      {modalData?.data?.nome ? (
        <span>
          <b>Nome do arquivo: </b> {modalData?.data?.nome}
        </span>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <span>
          <b>, Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </span>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <span>
          <b>, Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </span>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <span>
          <b>, Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </span>
      ) : (
        ''
      )}

      {modalData?.responsavel?.nomeUsuario ? (
        <span>
          <b>, Responsável: </b> {modalData?.responsavel?.nomeUsuario}
        </span>
      ) : (
        ''
      )}

      {/* 
     "nome_arquivo = 'Arquivo 1'
extensão = '.docx'
tipo = 'arquivo'
instituição = 'ANS'
responsavel_inclusao = 'Teste HMV'
data_inclusão = '22/06/2020 - 15:34:35'" */}

      {/* {modalData?.data?.nome ? (
        <span>
          <b>Nome do arquivo: </b> {modalData?.data?.nome || ''}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.extensao ? (
        <span>
          <b>, Extensão: </b> {modalData?.data?.extensao || ''}
        </span>
      ) : (
        ''
      )}

      {modalData?.data?.tipo ? (
        <span>
          <b>, Tipo: </b>{' '}
          {modalData?.tipo === 'FILE' ? 'Arquivo' : 'Link externo' || ''}
        </span>
      ) : (
        ''
      )} */}
    </div>
  );
}
